import React, {FunctionComponent} from 'react';
import ChallengeButton from '/src/ui/challengeProtocol/ChallengeButton'
import {Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {theme} from '/src/assets/theme';
import {ParticipantArrow} from '/src/ui/shared/challengeProtocol/Arrow';
import cs from 'classnames'
import {useTranslation} from 'react-i18next';
import {date, TrackAuditResult} from '/src/domain/challenges/ChallengeAuditData';


interface AuditButtonProps {
    isExpanded: boolean;
    auditResult: TrackAuditResult,
    startTime: date
}


const AuditButton: FunctionComponent<AuditButtonProps> = ({
                                                              isExpanded,
                                                              auditResult,
                                                              startTime
                                                          }) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const statusMessage = Boolean(auditResult.dsqReason)
        ? `${t('trackDsq')} ${t(auditResult.dsqReason!!)}`
        : t(auditResult.audit);

    return (
        <Grid container
              component={ChallengeButton}
              className={cs(classes.auditBtn,
                  {[classes.isActive]: auditResult.inProtocol},
                  {[classes.isNotActive]: Boolean(auditResult.dsqReason) || auditResult.audit === 'statusNotRunWindow'},
              )}
              alignItems="center"
              justifyContent="center"
              spacing={1}
        >
            <Grid item container alignItems="center" xs={1} className={classes.auditBtnCell}>
                <ParticipantArrow rotate={isExpanded}/>
            </Grid>
            <Grid item xs={4} className={classes.auditBtnCell}>
                {startTime}
            </Grid>
            <Grid item xs={6} className={classes.auditBtnCell}>
                {statusMessage}
            </Grid>

        </Grid>
    );
}

const useStyles = makeStyles({
    auditBtn: {
        width: '100%',
        margin: 0,
        backgroundColor: theme.lightPrimaryColor,
        padding: '0.5rem 0',
        fontSize: '0.9rem',
        fontWeight: 500
    },
    auditBtnCell: {
        overflowX: 'auto'
    },
    isActive: {
        backgroundColor: theme.trackInProtocol
    },
    isNotActive: {
        backgroundColor: theme.lightSecondaryColor
    },
})

export default AuditButton